const theme = {
    rainbow: {
        palette: {
            brand: '#d90024',
            success: '#6b9dbf',
            error: '#d3264b',
            mainBackground: '#ffffff',
        },
    },
    bootstrap: {
        green: '#31dddd',
        primary: '#d90024',
        secondary: '#dbdbdb',
        success: '#6b9dbf',
        danger: '#d3264b',
        warning: '#ffcc00',
        info: '#D6CBB9',

        appBlue: '#B5DCEA', // "appBlue/x-app-blue" now is "success"
        appBlue2: '#6fb2da',
        appBlue3: '#88bdda', // "appLightBlue/x-app-light-blue" now is "appBlue3/x-app-blue"
        appBlue4: '#4562cc', // "appBlueStrong/x-app-blue-strong" now is "appBlue4/x-app-blue-4"
        appBrown: '#d6cbb9',
        appGray: '#bbbbbb',
        appGray2: '#a1a1a1',
        appGray3: '#e1e1e1',
        appGray4: '#efefef', // "appLightGray/x-app-light-gray" now is "appGray4/x-app-gray-4"
        appGray5: '#757575', // "appDarkGray/x-app-dark-gray" now is "appGray5/x-app-gray-5"
        appGray6: '#e8e8e8',
        appGreen: '#07cf7c',

        textGray25: '#404040',
        textGray50: '#808080',
        textGray75: '#bfbfbf',

        menuBreakPoint: 1130,
        menuBreakPointPx: '1130px',
        gridBreakpoints: {
            xs: 0,
            sm: 575,
            md: 767,
            lg: 991,
            xl: 1199,
        },
        gridBreakpointsPx: {
            xs: '0',
            sm: '575px',
            md: '767px',
            lg: '991px',
            xl: '1199px',
        },
    },
};

export default theme;
